define.alias("ember-composable-helpers/helpers/pipe", "preview-grid/helpers/pipe");